"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _ = require("../");

var _ChartLineCompareTooltip = _interopRequireDefault(require("./ChartLineCompareTooltip"));

require("./ChartLineCompare.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

class ChartLineCompare extends _react.Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "getColors", () => {
      const theme = this.props.theme;
      return [theme.primaryColor || "black", "#999"];
    });

    _defineProperty(this, "renderTooltip", ({
      slice
    }) => {
      return _react.default.createElement(_ChartLineCompareTooltip.default, _extends({}, this.props, {
        slice: slice
      }));
    });

    _defineProperty(this, "getData", () => {
      const data = this.props.data;

      if (data && data.data) {
        const reverse = data.data.reverse();
        return _extends({}, data, {
          data: reverse
        });
      }

      return data;
    });
  }

  render() {
    const colors = this.getColors();
    const data = this.getData();
    return _react.default.createElement(_.ChartLine, _extends({}, this.props, {
      data: data,
      colors: colors,
      renderTooltip: this.renderTooltip
    }));
  }

}

_defineProperty(ChartLineCompare, "defaultProps", {
  enableSlices: "x",
  useMesh: false
});

var _default = ChartLineCompare;
exports.default = _default;
module.exports = exports.default;